import { ErrorFieldEntity } from '../../../shared/http.types';
import { MappedErrors, Step2Field } from './account.types';

export function filterStep2ServerErrors(errors: ErrorFieldEntity[]): MappedErrors {
  const fieldsSet = getStep2FieldsSet();

  return errors.reduce((acc, error) => {
    if (fieldsSet.has(error.field as Step2Field)) {
      acc.handledErrors.push(error);
    } else {
      acc.unhandledErrors.push(error);
    }
    return acc;
  }, { unhandledErrors: [], handledErrors: [] } as MappedErrors)
}

export function getStep2FieldsSet(): Set<Step2Field> {
  const fieldsSet: Record<Step2Field, any> = {
    [Step2Field.DOMAIN]: true,
    [Step2Field.CURRENCY]: true,
    [Step2Field.NAME]: true,
  }
  return new Set<Step2Field>(Object.keys(fieldsSet) as Step2Field[]);
}
